
import { SiteMetadata } from './types/analysisTypes';

export const getMetadataFromStorage = (domain: string) => {
  try {
    const metadataKey = `metadata_${domain}`;
    const metadataJson = localStorage.getItem(metadataKey);
    if (metadataJson) {
      return JSON.parse(metadataJson);
    }
  } catch (error) {
    console.error('Error loading metadata', error);
  }
  return null;
};

export const saveMetadataToStorage = (domain: string, metadataData: SiteMetadata) => {
  try {
    const metadataKey = `metadata_${domain}`;
    localStorage.setItem(metadataKey, JSON.stringify({
      ...metadataData,
      lastUpdated: new Date().toISOString()
    }));
  } catch (error) {
    console.error('Error saving metadata', error);
  }
};
